import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
var _hoisted_1 = {
  class: "contest-tabs"
};
var _hoisted_2 = {
  class: "tabs-list"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = {
  key: 0,
  class: "status"
};
var _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  active: "",
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M18 12.5C18 16.0899 15.0899 19 11.5 19C7.91015 19 5 16.0899 5 12.5C5 8.91015 7.91015 6 11.5 6C15.0899 6 18 8.91015 18 12.5Z",
  fill: "#FFCEB2"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M18 3L15 1",
  stroke: "#FF5C00",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M3 3L6 1",
  stroke: "#FF5C00",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M10 7V12H15",
  stroke: "#FF5C00",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}), /*#__PURE__*/_createElementVNode("circle", {
  cx: "10.5",
  cy: "11.5",
  r: "8.75",
  stroke: "#FF5C00",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
})], -1);
var _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"21\" height=\"21\" viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 12.5C18 16.0899 15.0899 19 11.5 19C7.91015 19 5 16.0899 5 12.5C5 8.91015 7.91015 6 11.5 6C15.0899 6 18 8.91015 18 12.5Z\" fill=\"#EEEEEE\"></path><path d=\"M18 3L15 1\" stroke=\"#999999\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M3 3L6 1\" stroke=\"#999999\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10 7V12H15\" stroke=\"#999999\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><circle cx=\"10.5\" cy=\"11.5\" r=\"8.75\" stroke=\"#999999\" stroke-width=\"1.5\" stroke-linecap=\"round\"></circle></svg>", 1);
var _hoisted_7 = [_hoisted_5, _hoisted_6];
var _hoisted_8 = {
  key: 1,
  class: "status"
};
var _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  active: "",
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("g", {
  "clip-path": "url(#clip0_1439_810)"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z",
  fill: "#FFCEB2"
}), /*#__PURE__*/_createElementVNode("circle", {
  cx: "10.5",
  cy: "10.5",
  r: "9.75",
  stroke: "#FF5C00",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M13.7335 11.2633L9.96452 13.5346C9.29803 13.9363 8.44836 13.4563 8.44836 12.6782L8.44833 7.56034C8.44833 6.73476 9.39219 6.26479 10.051 6.76235L13.82 9.6088C14.3849 10.0354 14.3398 10.8979 13.7335 11.2633Z",
  fill: "#FF5C00"
})]), /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_1439_810"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "21",
  height: "21",
  fill: "white"
})])])], -1);
var _hoisted_10 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"21\" height=\"21\" viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1439_801)\"><path d=\"M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z\" fill=\"#EEEEEE\"></path><circle cx=\"10.5\" cy=\"10.5\" r=\"9.75\" stroke=\"#999999\" stroke-width=\"1.5\" stroke-linecap=\"round\"></circle><path d=\"M13.7335 11.2633L9.96452 13.5346C9.29803 13.9363 8.44836 13.4563 8.44836 12.6782L8.44833 7.56034C8.44833 6.73476 9.39219 6.26479 10.051 6.76235L13.82 9.6088C14.3849 10.0354 14.3398 10.8979 13.7335 11.2633Z\" fill=\"#999999\"></path></g><defs><clipPath id=\"clip0_1439_801\"><rect width=\"21\" height=\"21\" fill=\"white\"></rect></clipPath></defs></svg>", 1);
var _hoisted_11 = [_hoisted_9, _hoisted_10];
var _hoisted_12 = {
  key: 2,
  class: "status"
};
var _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  active: "",
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [/*#__PURE__*/_createElementVNode("g", {
  "clip-path": "url(#clip0_1439_816)"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z",
  fill: "#FFCEB2"
}), /*#__PURE__*/_createElementVNode("circle", {
  cx: "10.5",
  cy: "10.5",
  r: "9.75",
  stroke: "#FF5C00",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}), /*#__PURE__*/_createElementVNode("path", {
  d: "M7 10.5L9.79765 12.7359L14.5 8",
  stroke: "#FF5C00",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
})]), /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_1439_816"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "21",
  height: "21",
  fill: "white"
})])])], -1);
var _hoisted_14 = /*#__PURE__*/_createStaticVNode("<svg class=\"icon\" width=\"21\" height=\"21\" viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_1439_806)\"><path d=\"M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12Z\" fill=\"#EEEEEE\"></path><circle cx=\"10.5\" cy=\"10.5\" r=\"9.75\" stroke=\"#999999\" stroke-width=\"1.5\" stroke-linecap=\"round\"></circle><path d=\"M7 10.5L9.79765 12.7359L14.5 8\" stroke=\"#999999\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_1439_806\"><rect width=\"21\" height=\"21\" fill=\"white\"></rect></clipPath></defs></svg>", 1);
var _hoisted_15 = [_hoisted_13, _hoisted_14];
var _hoisted_16 = {
  class: "txt"
};
import { reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { StateMap } from '../../js/utils.ts';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var _a;
    var router = useRouter();
    var route = useRoute();
    var state = reactive({
      activeTab: ((_a = route.query) === null || _a === void 0 ? void 0 : _a.state) || 'inProgressState',
      list: Object.keys(StateMap).map(function (k) {
        return {
          state: k,
          txt: StateMap[k].text
        };
      })
    });
    var onTabClick = function (item) {
      state.activeTab = item.state;
      router.replace({
        query: {
          state: item.state
        }
      });
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).list, function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tabs-item", {
            active: _unref(state).activeTab === item.state
          }]),
          key: item.status,
          onClick: function ($event) {
            return onTabClick(item);
          }
        }, [item.state === 'inProgressState' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7)) : _createCommentVNode("", true), item.state === 'waitState' ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11)) : _createCommentVNode("", true), item.state === 'endState' ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_16, _toDisplayString(item.txt), 1)], 10, _hoisted_3);
      }), 128))])]);
    };
  }
});